import { FacebookLoginToGameAction } from './facebook-login-to-game';
import { HTTP_STATUS_NO_CONTENT, HTTP_STATUS_INTERNAL_SERVER_ERROR } from '../../../helpers/validation/common';
import { mockedRedirectResponse } from '../mocks';

const successMock: FacebookLoginToGameAction = async () => {
	return Promise.resolve({
		...mockedRedirectResponse,
		status: HTTP_STATUS_NO_CONTENT,
	});
};

const failMock: FacebookLoginToGameAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
		errors: [{ code: 'be.api.auth.facebook.login-to-game-failed', message: 'Facebook login to game failed' }],
	});
};

export const facebookLoginToGameMocks: {
	success: FacebookLoginToGameAction;
	fail: FacebookLoginToGameAction;
} = {
	success: successMock,
	fail: failMock,
};
